module.exports = __webpack_public_path__ + "static/img/peixun.c160f458.png";